<template>
  <div>
    <!-- <current-path /> -->
    <v-toolbar flat>
      <v-toolbar-title>{{ $t("headings.subscriptions") }}</v-toolbar-title>
      <v-spacer> </v-spacer>
    </v-toolbar>
    <v-container fluid class="filter-area">
      <global-search-filter :queries="queries" ref="search_filter_ref" />
    </v-container>
    <!-- table -->
    <wrapping-table
      ref="table_ref"
      :headersName="headers"
      pathName="subscriptions"
      class="table-row"
      dialogWidth="500"
    >
      <template slot-scope="{ item }">
        <td class="text-sm-center">{{ item.email }}</td>
      </template>
    </wrapping-table>
    <!-- table -->
  </div>
</template>

<script>
export default {
  name: "contactMessage",
  data() {
    return {
      headers: ["email"],
      queries: {
        query: {
          email: ""
        }
      }
    };
  },
  methods: {
    ClearAllFilters() {
      this.$refs.search_filter_ref.ClearFilter();
      this.$router.push({ query: {} });
    }
  }
};
</script>
